<template>
  <div >
    <label :for='valueKey'>
      {{label}}
      <validation-message
        :required="required"
        :invalid="invalid"
        :errorMessage="errorMessage" />
    </label>
    <label>
      <input
        :class='modifier'
        :type='type'
        :id='valueKey'
        v-model="keywordSearch"
        @focus="onFocus"
        :name="valueKey"
        :disabled='disabled ? "disabled" : null'
        :required="required"
        :pattern="pattern"
        :placeholder="placeHolderText"
        @keyup="onKeyUp(keywordSearch)"
      />
    </label>
    <ul class="autocomplete-results" v-if="resultItems.length > 0">
      <li class="autocomplete-result"
          v-for="(item,i) in resultItems" :key="i"
          @click="keywordSearch='';onSelected(item[itemId], item[itemText])">
        {{ item[itemText] }}
      </li>
    </ul>

  </div>
</template>

<script>
  import ValueInputBindings from '@mixins/ValueInputBindings'
  import ValidationMessage from '@atoms/ValidationMessage'
  export default {
    mixins: [ ValueInputBindings ],
    components: { ValidationMessage },
    props: {
      placeHolderText: String,
      onKeyUp: Function,
      onSelected: Function,
      resultItems: Array,
      itemText: String,
      itemId: String,
      autocomplete: {
        type: Boolean,
        default: false
      },
      modifier: {
        type: String,
        default: 'form-input'
      },
      pattern: {
        type: String,
        default: null
      },
      type: {
        type: String,
        default: 'text'
      },
      required: {
        type: Boolean,
        default: false
      },
      label: String,
      value: [Number, String, Date],
      valueKey: String,
      disabled: Boolean,
      onFocus: {
        type: Function,
        default() {
        }
      },
      onChange: {
        type: Function,
        default() {
        }
      },
      invalid: {
        type: Boolean,
        default: false
      },
      errorMessage: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        keywordSearch: ''
      }
    }
  }
</script>
